<template>
	<div>
		<v-list v-for="item in items" :key="item.id" class="purchased">
			<v-list-item :class="item.paymentStatus">


				<template v-if="(item.category === 'addons') || (item.category === 'ow')">
					<v-list-item-content>

						{{ item.name }} ${{ item.price }}
					</v-list-item-content>
				</template>

				<template v-else-if="item.category === 'merch'">
					<v-list-item-content>

						{{ item.name }} {{ item.m_l }} {{ item.colour }} {{ item.size }} ${{ item.price }}

					</v-list-item-content>
				</template>

				<template v-else-if="item.category === 'tips'">
					<v-list-item-content>

						{{ item.name }} {{ item.notes }} ${{ item.price }}
					</v-list-item-content>
				</template>

				<template v-else-if="item.category === 'split'">
					<v-list-item-content>

						{{ item.notes }} ${{ item.price }}
					</v-list-item-content>
				</template>



				<v-list-item-avatar>

					<v-avatar v-if="item.paymentStatus === 'paid' && status >= 2" tile>
						<v-btn @click="voidItem(item)"
							v-if="item.category != 'ow' && item.category != 'pckg' && item.category != 'split'"
							icon><v-icon>mdi-cash-refund</v-icon></v-btn>
					</v-avatar>

					<v-avatar v-if="item.paymentStatus == 'pending'" tile>
						<v-btn @click="deleteItem(item)"
							v-if="item.category != 'ow' && item.category != 'pckg' && item.category != 'split'" icon
							class="red--text"><v-icon>mdi-delete-forever</v-icon></v-btn>
					</v-avatar>
				</v-list-item-avatar>
			</v-list-item>
		</v-list>
	</div>
</template>
<style> .purchased.v-list {
 	padding: 0;
 }

 /*.v-data-table__expanded__content .purchased.v-list { max-width: 85%; margin: auto; }*/
 .voided,
 .canceled {
 	text-decoration: line-through;
 }

 .deleted {
 	display: none
 }

 .credit .v-list-item__content {
 	display: inline;
 }

 .v-list-item .credit span {
 	display: inline;
 }
</style>
}


<script>

export default {
	props: ['items', 'customer_id', 'status'],

	methods: {

		voidItem(item) {


			const index = this.items.indexOf(item)

			item.paymentStatus = 'canceled'

			// confirm('Are you sure you want to cancel this item?') && 
			axios.put('/api/customers/void/' + this.customer_id, { item: item })
				.then(response => {

					// console.log(response.data)

				})
				.catch(err => {
					console.log(err)
				})

		},

		deleteItem(item) {

			const index = this.items.indexOf(item)
			item.paymentStatus = 'deleted'


			axios.put('/api/customers/void/' + this.customer_id, { item: item })
				.then(response => {

					// console.log(response.data)

					this.items.splice(index, 1)
					this.$emit('removefromBasket', item)

				})
				.catch(err => {
					console.log(err)
				})

		},

		removefromBasket(item) {
			this.$emit('removefromBasket', item)
		}
	}
}
</script>

<style></style>